export const HEADER = {
  MOBILE_HEIGHT: 87,
  MAIN_DESKTOP_HEIGHT: 52,
};
